import React from 'react'

export interface TourGuideProps {
  // wrapper functions to start and stop tour
  startTour: () => void
  stopTour: () => void

  // Handle starting init tour
  requestTourStart: boolean
  requestStartTour: () => void

  // tour specific state
  currentStep: number
  setCurrentStep: (step: number) => void
  hasCompletedTour: boolean
  run: boolean

  // Stages in the tour
  setOverviewSectionComplete: (clicked: boolean) => void
  setProductSectionComplete: (clicked: boolean) => void
  overviewSectionComplete: boolean
  productSectionComplete: boolean
  backFromPortfolio: boolean
  setBackFromPortfolio: (state: boolean) => void
  mobileBuySellComplete: 'IDLE' | 'GOBACK' | 'CLICKED' | 'COMPLETE'
  setMobileBuySellComplete: (state: 'IDLE' | 'CLICKED' | 'COMPLETE') => void
  mobilePortfolio: 'IDLE' | 'GOBACK' | 'CLICKED' | 'COMPLETE'
  setMobilePortfolio: (state: 'IDLE' | 'CLICKED' | 'COMPLETE') => void
  portfolioState: 'IDLE' | 'CLICKED' | 'OPEN'
  setPortfolioState: (state: 'IDLE' | 'CLICKED' | 'OPEN') => void
  setPerformanceSectionOpen: (state: 'OPEN' | 'CLOSED') => void
  performanceSectionOpen: 'OPEN' | 'CLOSED'
  menuOpen: 'REQUESTOPEN' | 'OPEN' | 'CLOSED'
  setMenuOpen: (state: 'REQUESTOPEN' | 'OPEN' | 'CLOSED') => void
}

export const TourGuideContext = React.createContext<TourGuideProps | undefined>(undefined)
